




























































































































































































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { downloadFile, timeFormat, jsIntString } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import {
  GetDialListReq,
  CreateQualityInspectionVoipReq,
} from "@/pbjs/xcommon/dialer_pb";
import { dialerServiceClient } from "@/api/dialerServiceClient";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// import { CreateQualityInspectionVoipReq } from "@/pbjs/xcommon/ticket_pb";
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
  dialerClient,
} from "@/api/index";
import { GetTicketListParamReq } from "@/pbjs/external/ticket/ticket_pb";
@Component({
  name: "CallRecordQuery",
})
export default class PerformanceManagement extends Vue {
  @Provide() private txt: any = this.$t;
  @Provide() private QualityEnspectionOptions: any = [];
  @Provide() private AistatusOptions: any = [
    { id: "1", val: "dashbordDy.Notinspected" },
    { id: "2", val: "dashbordDy.Qualityinspected" },
  ];
  @Provide() private audioSrc: any = ""; // 音频src属性
  @Provide() private audioSrcNext: any = ""; // 录音文件src属性
  @Provide() private searchForm: any = {
    Dialid: null, // 拨打ID
    Orderid: null, // 订单ID
    Assignuser: null, // 分配员工姓名
    ItemId: null, // 工单分类
    Extnumber: null, // 分机号
    Disnumber: null, // 主叫号码
    Destnumber: null, // 被叫号码
    Supplier: null, // 供应商名称
    startTimerange: null, // 拨打时间戳
    Createtimerange: null, // 记录创建时间
    Roleids: null, // 角色ID
    QualityEnspection: "",
    Aistatus: "",
    Aiscorerange1: "",
    Aiscorerange2: "",
    talkTime1: "",
    talkTime2: "",
  }; // lee 搜索表单
  @Provide() private rules: any = {
    startTimerange: [
      {
        type: "date",
        required: true,
        message: "pls choose start time at least",
        trigger: "change",
      },
    ],
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private resultData: any = []; // lee table列表
  @Provide() private resultTicketItemData: any = []; // lee TicketItem列表
  @Provide() private resultRoleIDsData: any = []; // lee RoleIDs列表
  @Provide() private resultSupplierData: any = []; // lee Supplie列表
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pagnition: any = pagnition; // lee 分页参数
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private disabled: boolean = false;
  @Provide() private pagerCount: number = 0; // lee 分页参数
  @Provide() private isSearchFormActionDone: boolean = false; // lee 搜索按钮的loading开关
  @Provide() private isExportFormActionDone: boolean = false;
  // @Provide() private videoLoading: boolean = false; // 录音文件loading 展示
  // @Provide() private videoShow: boolean = false; // audio 展示
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getExtenListParam(); // 获取列表数据
    this.getTicketListParam();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //生成工单
  private GenerateTicket(row: any) {
    // row.disabled=true
    let request: any = new CreateQualityInspectionVoipReq();
    request.setCommonin(setCommon());
    request.setRelatedid(row.id);
    dialerClient.createQualityInspectionVoip(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.code === 0) {
            row.isShow = false;
            this.$message.success("success");
          }
        }
        if (err) {
          row.isShow = true;
          if (err.code == 16) {
            this.$router.push("./login");
          } else {
            this.$message.error(err.errmsg || err.message);
          }
        }
      }
    );
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  // 搜索操作
  private searchFormAction() {
    this.testForm(true);
  }
  private testForm(type: boolean) {
    let _form: any = this.$refs["searchForm"];
    _form.validate((valid: any, obj: any) => {
      if (valid) {
        if (this.testSearchForm()) {
          //检验表单
          if (type == true) {
            this.isSearchFormActionDone = true;
            this.pageIndex = 1;
            this.getExtenList();
          } else {
            this.exportrequst();
          }
        }
        return true;
      } else {
        return false;
      }
    });
  }
  //d导出接口
  private async exportrequst() {
    let arg: any = this.dwSearchAction();
    // 判断日期是否符合
    const curDate = new Date().getTime();
    const formDate = new Date(this.searchForm.startTimerange[1]).getTime(); // 结束时间不能大于当前时间
    if (formDate - curDate > 0) {
      this.$message.error("Error: pls select  correct time.");
      this.isExportFormActionDone = false;
      return;
    }
    // return
    const { exportDialRecords }: any = await import("@/request/getDialList");
    let res = await exportDialRecords(arg, this);
    // this.isExportFormActionDone = false;
    // return
    if (res?.array[0] && res?.array[0][0] === 2) {
      // 服务器错误
      this.$message({
        message: "DError, please contact admin!",
        type: "error",
        duration: 2000,
      });
    } else if (res?.array[0] && res?.array[0][0] === 6) {
      // 没有文件
      this.$message({
        message:
          "Data is being prepared, please do not click repeatedly, please wait!",
        type: "warning",
        duration: 2000,
      });
    } else if (res?.array[0] && res?.array[0][0] === 12) {
      // 没有文件
      this.$message({
        message: "The data is being prepared, please wait 5 minutes!",
        type: "warning",
        duration: 2000,
      });
    } else if (res && res.array[3]) {
      if (res.array[3] && res.array[3].length && res.array[3]?.length > 0) {
        const blob = new Blob([res.array[3]], {
          type: "octet/stream",
        });

        // 没有文件
        this.$message({
          message: "Data is downloading！",
          type: "warning",
          duration: 2000,
        });
        downloadFile(blob, res.array[2]);
      }
    }
    this.isExportFormActionDone = false;
  }
  // lee 搜索操作的判断
  private testSearchForm(): any {
    //  日期为必选
    if (this.searchForm.startTimerange) {
      if (this.searchForm.Orderid) {
        if (this.searchForm.Orderid && jsIntString(this.searchForm.Orderid)) {
          return true;
        } else {
          this.$message.error("the orderID must be number!");
          return false;
        }
      }
      if (this.searchForm.talkTime2 && this.searchForm.talkTime1) {
        if (this.searchForm.talkTime2 !== this.searchForm.talkTime1) {
          return true;
        } else {
          this.$message.error("pls checke the value");
          return false;
        }
      }

      return true;
    } else {
      this.$message.error("pls choose start time at least!");
      return false;
    }
  }
  private getTicketListParamFuc(data: any) {
    this.QualityEnspectionOptions = data.ticketstatusList;
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // lgy 号码脱敏，保留后四位，前面按位数打星号
  private numberEncryption(number: string) {
    let len: number = number.length - 4;
    let numStrPre: string = number.substring(len, len + 4);
    let newNum: string = "";
    for (let i = 0; i < len; i++) {
      newNum += "*";
    }
    return newNum + numStrPre;
  }
  // lee 获取列表
  private async getExtenList() {
    let _arg: any = this.dwSearchAction();
    const { getDialList }: any = await import("@/request/getDialList");
    let res = await getDialList(_arg, this);
    this.isSearchFormActionDone = false;
    if (res) {
      // _this.RangeType = 0;
      this.pagerCount = res.total ? res.total : res.pageout.total;
      this.resultData = res.dialinfosList.map((item: any) => {
        item.dialway =
          item.dialway == 1
            ? this.$tc("tableLgy.AutoCall")
            : this.$tc("tableLgy.ManualCall");
        for (let key in item.dialinfo) {
          if (
            key !== "hangupdirection" &&
            key !== "hangupcause" &&
            key !== "calldirection" &&
            key !== "callmethod"
          ) {
            item["" + key + ""] = item.dialinfo["" + key + ""];
          }
        }
        item["ctime"] = timeFormat(item.dialinfo["ctime"]);
        item["play"] = true; // 设置播放状态
        item["downLoad"] = true; // 设置下载状态
        item["starttime"] = timeFormat(item.dialinfo["starttimestamp"]);
        item["answertime"] = timeFormat(item.dialinfo["answertimestamp"]);
        item["endtime"] = timeFormat(item.dialinfo["endtimestamp"]);
        // item["wtime"] = item.dialinfo["answertimestamp"]
        //   ? item.dialinfo["answertimestamp"] - item.dialinfo["starttimestamp"]
        //   : "---";
        item["IsDial"] = item["isdial"]
          ? this.txt("ticket.Connect")
          : this.txt("ticket.NotConnected");
        // 通话记录号码脱敏
        item["destnumber"] = this.numberEncryption(item["destnumber"]);
        item["isShow"] = item.createaudiocase == 1 ? true : false;
        this.$set(item, "videoLoading", false); // 录音文件loading 展示
        this.$set(item, "videoShow", false); //audio 展示
        return item;
      });
    }
  }
  // lee 获取查询参数
  private async getExtenListParam() {
    const { getDialListParam }: any = await import("@/request/getDialList");
    let res = await getDialListParam();
    if (res) {
      this.resultTicketItemData =
        res && res.ticketitemList ? res.ticketitemList : []; // lee TicketItem列表
      this.resultRoleIDsData = res && res.roleidsList ? res.roleidsList : []; // lee RoleIDs列表
      this.resultSupplierData = res && res.supplierMap ? res.supplierMap : []; // lee Supplie列表
    }
  }
  //  lee 抽离查询公共处理部分
  private dwSearchAction(): any {

    let _arg: any = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      IsDial: this.searchForm.IsDial, //是否拨通
      Dialid: jsIntString(this.searchForm.Dialid)
        ? this.searchForm.Dialid
        : null, // 拨打ID
      Sid: this.searchForm.Sid, // Sid
      Orderid: jsIntString(this.searchForm.Orderid)
        ? this.searchForm.Orderid
        : null, // 订单ID
      Assignuser: this.searchForm.Assignuser, // 分配员工姓名
      ItemId: this.searchForm.ItemId ? Number(this.searchForm.ItemId) : null, // 工单分类
      Extnumber: this.searchForm.Extnumber, // 分机号
      Disnumber: this.searchForm.Disnumber, // 主叫号码
      Destnumber: this.searchForm.Destnumber, // 被叫号码
      Supplier: this.searchForm.Supplier
        ? Number(this.searchForm.Supplier)
        : null, // 供应商名称
      startTimerange: this.searchForm.startTimerange
        ? timeFormat(this.searchForm.startTimerange[0]) +
          " - " +
          timeFormat(this.searchForm.startTimerange[1])
        : null, // 拨打时间戳
      Createtimerange: this.searchForm.Createtimerange
        ? timeFormat(this.searchForm.Createtimerange[0]) +
          " - " +
          timeFormat(this.searchForm.Createtimerange[1])
        : null, // 记录创建时间
      Roleids: this.searchForm.Roleids ? this.searchForm.Roleids + "" : null, // 角色ID
      // Aistauts: this.searchForm.Aistatus ? this.searchForm.Aistatus + "" : null,
      // QualityEnspection: this.searchForm.QualityEnspection
      //   ? this.searchForm.QualityEnspection + ""
      //   : null,
      // Aiscorerange:
      //   this.searchForm.Aiscorerange1 + " - " + this.searchForm.Aiscorerange2,
      talkTime:
        this.searchForm.talkTime2 > this.searchForm.talkTime1
          ? this.searchForm.talkTime1 + " - " + this.searchForm.talkTime2
          : this.searchForm.talkTime2 + " - " + this.searchForm.talkTime1,
    };
    return _arg;
  }
  // lee 获取录音文件
  private async getFileInfo(row: any, index: number) {
    // index  1：播放  2：下载
    if (index == 1 && row.play) {
      this.resultData.map((item: any) => {
        item.play = true;
        return item;
      });
      row.play = false;
      const { getDialListMedia }: any = await import("@/request/getDialList");
      let _arg = {
        VOIPRecordID: jsIntString(row.id) ? row.id : null,
      };
      let response = await getDialListMedia(_arg);
      if (response) {
        if (response.mediabody) {
          let bStr = atob(response.mediabody),
            n = bStr.length,
            unit8Array = new Uint8Array(n);
          while (n--) {
            unit8Array[n] = bStr.charCodeAt(n);
          }
          const blob = new Blob([unit8Array], {
            type: "application/json",
          });
          if (document.getElementById("audioId")) {
            document.body.removeChild(
              document.getElementById("audioId") as any
            );
          }
          let _audio = document.createElement("audio");
          _audio.setAttribute("id", "audioId");
          _audio.setAttribute("width", "100");
          _audio.setAttribute("height", "100");
          _audio.setAttribute("autoplay", "autoplay");
          this.audioSrc = URL.createObjectURL(blob);
          (<any>_audio).src = this.audioSrc;
          (<any>_audio).removeEventListener(
            "canplay",
            () => {
              window.URL.revokeObjectURL((<any>_audio).src);
              row.play = true;
            },
            false
          );
          (<any>_audio).addEventListener(
            "canplay",
            () => {
              window.URL.revokeObjectURL((<any>_audio).src);
              row.play = false;
            },
            false
          );
          (<any>_audio).addEventListener(
            "ended",
            () => {
              row.play = true;
            },
            false
          );
        }
      }
    } else if (index == 2) {
      const { getDialListMedia }: any = await import("@/request/getDialList");
      let _arg = {
        VOIPRecordID: jsIntString(row.id) ? row.id : null,
      };
      let response = await getDialListMedia(_arg);
      if (response) {
        if (response.mediabody) {
          let bStr = atob(response.mediabody),
            n = bStr.length,
            unit8Array = new Uint8Array(n);
          while (n--) {
            unit8Array[n] = bStr.charCodeAt(n);
          }
          // 下载
          let blob = new Blob([unit8Array], {
            type: "audio/mpeg",
          });
          let downa = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          downa.href = href;
          downa.download = `${row.id}`;
          document.body.appendChild(downa);
          downa.click();
          document.body.removeChild(downa);
          window.URL.revokeObjectURL(href);
        }
      }
    }
  }
  //  lee 导出操作
  private exportFormAction() {
    this.testForm(false);
  }
  // private getExtenList(type: boolean) {
  //   let _form: any = this.$refs["searchForm"];
  //   _form.validate((valid: any, obj: any) => {
  //     if (valid) {
  //       if (this.testSearchForm()) {
  //         if (type) {
  //           // this.pageIndex = 1;
  //           this.isSearchFormActionDone = true;
  //           this.getExtenListAction();
  //         } else {
  //           this.isExportFormActionDone = true;
  //           this.exportFormListAction();
  //         }
  //       }
  //       return true;
  //     } else {
  //       this.$message.error("pls choose time limit at least!");
  //       if (type) {
  //         this.isSearchFormActionDone = false;
  //       } else {
  //         this.isExportFormActionDone = false;
  //       }
  //       return false;
  //     }
  //   });
  // }

  // lee 获取录音文件
  private async getFileInfoV2(e: any, row: any, index: number) {
    row.videoLoading = true;
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: jsIntString(row.id) ? row.id : null,
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      row.videoLoading = false;
      row.videoShow = true;

      this.audioSrcNext =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
    }
  }
}
